import NotesIcon from '@mui/icons-material/Notes';
import { observer } from 'mobx-react';
import React from 'react';
import { InputAdornment, TextField } from 'lib/cortiUI';
import { FormElementWidget } from './FormElementWidget';
export const TextAreaElementWidget = observer(function TextAreaElementWidget({ model, }) {
    return (React.createElement(FormElementWidget, { model: model },
        React.createElement(TextField, { disabled: true, fullWidth: true, value: "", InputProps: {
                endAdornment: (React.createElement(InputAdornment, { position: "end" },
                    React.createElement(NotesIcon, { fontSize: "small" }))),
            } })));
});
